<template>
	<v-row cols="12" v-if="!disabled">
		<v-col sm="12" md="4">
			<v-text-field 
			v-model="phone_number"
			@input="update"
			:label="trans('user.phone_number')"
			outlined
			></v-text-field>
		</v-col>

		<v-col sm="12" md="4">
			<v-text-field 
			v-model="first_name"
			@input="update"
			:label="trans('user.first_name')" 
			outlined
			></v-text-field>
		</v-col>

		<v-col sm="12" md="4">
			<v-text-field 
			v-model="last_name"
			@input="update"
			:label="trans('user.last_name')" 
			outlined
			></v-text-field>
		</v-col>
	</v-row>	
</template>

<script>
	import _ from 'lodash';
	
	export default {
		props: [
			'label',
			'value',
			'error',
			'errorMessages',
			'defaults',
			'disabled',
		],
		data: () => ({
			autocomplete: null,
			phone_number: null,
			first_name: null,
			last_name: null,
		}),

		mounted: function() {
			this.phone_number 	= _.get(this.$props.value, 'phone_number', null);
			this.first_name 	= _.get(this.$props.value, 'first_name', null);
			this.last_name 		= _.get(this.$props.value, 'last_name', null);
		},

		methods: {
	        update: function(response) {
	            this.$emit('input', {
	                phone_number: 	this.phone_number,
	                first_name: 	this.first_name,
	                last_name: 		this.last_name,
	            });
	        },	        
		},
		
	}
</script>